import React from 'react';
import { connect } from 'react-redux';

import {
  followFeedUser,
  unfollowFeedUser,
  dismissFeedback,
  dismissFeedbackClick,
} from 'common/actions';
import ContainerPlayer from 'common/container-player';
import ContainerSection from 'common/container-section';
import ContainerType from 'common/container-subtype';
import CustomizeProp from 'common/prop-types/customize';
import FeedUserTypes from 'common/feed-user-type';
import TabWrapper from 'components/shared/profile-tabs/tab-wrapper';
import Timeline from 'components/shared/profile-tabs/timeline/timeline';
import UpcomingEvents from './upcoming-events';
import RecentScores from './recent-scores';
import DisplayAd from 'components/shared/display-ad';
import ads from '../../../utility/ads';
import DisplayAdModel from '../../../utility/ads/display-ad-model';
import browserDetect from '../../../utility/browser-detect';

// This is purely a dummy component for managing the timeline display
// in a way that takes advantage of our redux store.
// The actual DOM element lives in a partial view on the page, outside
// of the React app.
class TeamTimelineTab extends React.Component {
  static propTypes = {
    ads: React.PropTypes.object,
    convertTimesToLocal: React.PropTypes.bool.isRequired,
    customize: CustomizeProp.isRequired,
    dispatch: React.PropTypes.func.isRequired,
    feedback: React.PropTypes.shape({
      feedbackEnabled: React.PropTypes.bool.isRequired,
      feedbackSurveyUrl: React.PropTypes.string.isRequired,
      optionSelected: React.PropTypes.bool,
    }).isRequired,
    feedContentItems: React.PropTypes.arrayOf(React.PropTypes.object),
    canDismissFeedItems: React.PropTypes.bool,
    forcePublicView: React.PropTypes.bool,
    presetFilterType: React.PropTypes.number,
    isMobile: React.PropTypes.bool.isRequired,
    profileDateCreated: React.PropTypes.string,
    profileFuzzyDateCreated: React.PropTypes.string,
    team: React.PropTypes.shape({
      profileUrlBase: React.PropTypes.string.isRequired,
      schoolName: React.PropTypes.string.isRequired,
      tagline: React.PropTypes.string,
      teamId: React.PropTypes.string.isRequired,
      teamCoverImage: React.PropTypes.string.isRequired,
      teamLogoUri: React.PropTypes.string,
      teamName: React.PropTypes.string,
      sportName: React.PropTypes.string,
      recentEvents: React.PropTypes.array.isRequired,
      upcomingEvents: React.PropTypes.arrayOf(React.PropTypes.shape({
        gameId: React.PropTypes.string.isRequired,
        isHome: React.PropTypes.bool.isRequired,
        opponentName: React.PropTypes.string.isRequired,
        opponentTeamId: React.PropTypes.string,
        schoolAbbreviation: React.PropTypes.string.isRequired,
        primaryColor: React.PropTypes.string,
        secondaryColor: React.PropTypes.string,
        teamLogoUri: React.PropTypes.string,
        unixTime: React.PropTypes.number,
      })),
    }).isRequired,
    user: React.PropTypes.shape({
      isPrivilegedUser: React.PropTypes.bool,
      userId: React.PropTypes.string,
    }),
  }

  onFollowUnfollow(feedUserTypeId, feedUserRelatedId, isFollow) {
    const isCurrentProfile = feedUserTypeId === 2 && feedUserRelatedId === this.props.team.teamId;
    if (isFollow) {
      this.props.dispatch(followFeedUser(feedUserTypeId, feedUserRelatedId, isCurrentProfile));
    } else {
      this.props.dispatch(unfollowFeedUser(feedUserTypeId, feedUserRelatedId, isCurrentProfile));
    }
  }

  dismissFeedbackClick() {
    this.props.dispatch(dismissFeedbackClick(this.props.user.userId, this.props.team.teamId));
  }

  dismissFeedback() {
    this.props.dispatch(dismissFeedback(this.props.user.userId, this.props.team.teamId));
  }

  renderBio() {
    if (this.props.team.tagline) {
      return (
        <div className="bio">{this.props.team.tagline}</div>
      );
    }

    return null;
  }

  render() {
    const { upcomingEvents, recentEvents } = this.props.team;

    const teamFeedUser = {
      profileUrlBase: this.props.team.profileUrlBase,
      profileLogoUri: this.props.team.teamLogoUri,
      type: FeedUserTypes.Team,
      teamId: this.props.team.teamId,
      schoolName: this.props.team.schoolName,
      teamName: this.props.team.teamName,
      feedUserId: {
        type: FeedUserTypes.Team,
        relatedId: this.props.team.teamId,
      },
    };

    const logData = {
      containerSection: ContainerSection.Timeline,
      containerType: ContainerType.Team,
      player: ContainerPlayer.TimelineCard,
    };
    const isMobile = this.props.isMobile || browserDetect.isModernIPad;

    const displayAdModel = new DisplayAdModel('div-gpt-ad-1455209951409-0', 'Display_TeamTimeline_Desktop');

    return (
      <TabWrapper>
        <div className="timeline-tab">
          <div className="left-column">
          {this.renderBio()}
          <RecentScores events={recentEvents}
            sportName={this.props.team.sportName}
            divider={!!(recentEvents && recentEvents.length && this.props.team.tagline)}
            teamProfileUrlBase={this.props.team.profileUrlBase}
            convertTimesToLocal={this.props.convertTimesToLocal}/>
          <UpcomingEvents events={upcomingEvents}
            sportName={this.props.team.sportName}
            divider={!!(upcomingEvents && upcomingEvents.length && ((recentEvents && recentEvents.length)
            || this.props.team.tagline))}
            teamProfileUrlBase={this.props.team.profileUrlBase}
            convertTimesToLocal={this.props.convertTimesToLocal}/>
        </div>
          <Timeline
            ads={this.props.ads}
            currentUserId={this.props.user.userId}
            customize={this.props.customize}
            bannerImage={this.props.team.teamCoverImage}
            feedback={this.props.feedback}
            forcePublicView={this.props.forcePublicView}
            canDismissFeedItems={this.props.canDismissFeedItems}
            presetFilterType={this.props.presetFilterType}
            feedContentItems={this.props.feedContentItems}
            isMobile={isMobile}
            isPrivilegedUser={!!(this.props.user && this.props.user.isPrivilegedUser)}
            // I don't usually like passing dispatch down, but in this case I'm trying to
            // extend the TimelineTab which can dispatch generic actions (e.g. advance onboarding
            // step or give feedback) while profile-specific tabs can dispatch more context-aware
            // actions
            dispatch={this.props.dispatch}
            dismissFeedback={this.dismissFeedback.bind(this)}
            dismissClickFeedback={this.dismissFeedbackClick.bind(this)}
            feedUser={teamFeedUser}
            logData={logData}
            profileDateCreated={this.props.profileDateCreated}
            profileFuzzyDateCreated={this.props.profileFuzzyDateCreated}
          />
          <div className="right-column">
          {!isMobile
              ? <DisplayAd
                  id={displayAdModel.getId()}
                  path={displayAdModel.getPath()}
                  sizes={[ads.sizes.MediumRectangle]}
                  adSizeMapping={ads.mappings.all}
                />
              : null}
          </div>
        </div>
      </TabWrapper>
    );
  }
}

function select(state) {
  const {
    customize,
    dispatch,
    feedback,
    forcePublicView,
    isMobile,
    team,
    timeline,
    user,
  } = state;

  return {
    customize,
    dispatch,
    feedback,
    forcePublicView,
    isMobile,
    team,
    timeline,
    user,
  };
}

export default connect(select)(TeamTimelineTab);
